module.exports = function() {

  return function(gram) {
    if (! gram) return null;

    return Math.floor(gram / 1000) + ' kg';
  };

};


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/filters/weightInKg.js
 ** module id = 167
 ** module chunks = 1
 **/